import type { AttributionContext } from "@next-platform/packages-ts-types";
import { getAttributionContext } from "@next-platform/client-common-core";

/**
 * Non-blocking wrapper around `getAttributionContext`: returns the
 * persisted envelope, or `undefined` on any read failure (corrupted
 * JSON, storage quota, library error, envelope version mismatch, etc.).
 *
 * Single source of truth for the swallow-and-default-to-undefined
 * contract shared by every call site that attaches attribution to a
 * request payload (checkout `submitOrder`, `altPaymentRedirect`, user
 * creation, and the 12 alt-payment endpoints landing in NX-9074).
 *
 * Attribution is observational, not required — a storage read must
 * never surface as an unhandled rejection that breaks a core flow.
 */
export async function safeGetAttributionContext(): Promise<AttributionContext | undefined> {
  try {
    return await getAttributionContext();
  } catch {
    return undefined;
  }
}

export default safeGetAttributionContext;
